export default class StantConfigureDecimal
  @configure_decimal_places: (total, round = 2) ->
    return get_only_two_decimal_places(total) if (/^\d+\.\d{2}/.test(total))  
    total.toFixed(round)

  get_only_two_decimal_places = (value) ->
    value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
